module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-topup"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column expanded"
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v("TU" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
    staticClass: "column shrink pr-0"
  }, [_c('div', {
    staticClass: "fiel-content"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at)))])])])]), _c('div', {
    staticClass: "row text-center pt-0"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Amount")]), _c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Transaction")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'transaction',
        params: {
          id: _vm.item.transaction.id
        }
      }
    }
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v("TR" + _vm._s((_vm.item.transaction.id)))])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f2ab669!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/TopUp.vue
// module id = 2423
// module chunks = 1